<template>
  <div>
    <input type="file" @change="handleFileUpload" accept=".csv">

    Bulk
    <input type="file" @change="handleFileUploadBulk" accept=".csv">
  </div>
</template>

<script>
export default {
  data () {
    return {
      uploadConfig: null
    }
  },
  computed: {
    event_id () {
      return this.$store.state.admin.adminData.event.event_id
    }
  },
  methods: {
    handleFileUpload (event) {
      const file = event.target.files[0]
      this.uploadFile(file)
    },
    uploadFile (file) {
      // Perform any necessary file validation or preprocessing here
      // Send the file to the backend for processing
      const formData = new FormData()
      formData.append('file', file)
      this.axios.post(process.env.VUE_APP_ROOT_API + '/importClassList', formData)
        .then(response => {
          this.uploadConfig = response.data.config
          this.configUploaded()
          // Handle the response from the server if needed
        })
        .catch(() => {
          // Handle any errors that occur during the file upload
        })
    },
    handleFileUploadBulk (event) {
      const file = event.target.files[0]
      this.uploadFileBulk(file)
    },
    uploadFileBulk (file) {
      // Perform any necessary file validation or preprocessing here
      // Send the file to the backend for processing
      const formData = new FormData()
      formData.append('file', file)
      this.axios.post(process.env.VUE_APP_ROOT_API + `/importClassList?bulk=true&event_id=${this.event_id}`, formData)
        .then(response => {
          this.uploadConfig = response.data.config
          this.configUploaded()
          // Handle the response from the server if needed
        })
        .catch(() => {
          // Handle any errors that occur during the file upload
        })
    },
    configUploaded () {
      this.$emit('configChange', this.uploadConfig)
    }
  }
}
</script>

<style>

</style>
